export default {"src":"/_next/static/media/hero_image.734a5c16.svg","height":596,"width":1440};